import { Box, Tooltip } from '@mui/material';
import { getLastRelease } from '../../../releases';

export const Version = () => {
  const v = getLastRelease();
  return (
    <div className="flex flex-row items-center justify-center py-2">
      <Tooltip title={v.date.toDateString() + ': ' + v.notes}>
        <Box sx={{ color: '#ddd', fontSize: '0.8em', fontWeight: 700 }}>
          version {v.version}
        </Box>
      </Tooltip>
    </div>
  );
};
